import { Link } from 'react-router-dom';
import { Card } from '../../components/primitives';
import { Icon } from '../../components/Icon';

export function NotFoundPage(): JSX.Element {
  return (
    <Card>
      <div className="state">
        <span className="state__icon">
          <Icon name="search" size={19} />
        </span>
        <span className="state__title">La página no existe</span>
        <span className="state__msg">
          La dirección utilizada no corresponde a ningún módulo de la plataforma. Puede que el enlace
          esté desactualizado o que su perfil ya no tenga acceso a esa sección.
        </span>
        <Link className="btn" to="/">
          Volver al inicio
        </Link>
      </div>
    </Card>
  );
}
